import React from 'react';
import {
  Box,
  Container,
  Typography,
  Avatar,
  IconButton,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ChatInterface from '../components/Chat/ChatInterface';
import { useNavigate } from 'react-router-dom';

const ModernHome = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#1e1e2e' }}>
      {/* Botón Admin flotante */}
      <IconButton
        sx={{
          position: 'fixed',
          top: 20,
          right: 20,
          bgcolor: 'rgba(76, 175, 80, 0.9)',
          color: 'white',
          zIndex: 1000,
          '&:hover': {
            bgcolor: '#4CAF50',
          },
        }}
        onClick={() => navigate('/login')}
      >
        <AdminPanelSettingsIcon />
      </IconButton>

      {/* Hero Section con logo */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1B5E20 0%, #4CAF50 100%)',
          py: 6,
          px: 3,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            {/* Logo de Enervia */}
            <Avatar
              src="/enervia_logo.png"
              alt="Enervia"
              sx={{
                width: 120,
                height: 120,
                mx: 'auto',
                mb: 2,
                border: '4px solid rgba(255, 255, 255, 0.3)',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                bgcolor: 'white',
              }}
            />

            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Enervia
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 500, mb: 3, opacity: 0.9 }}>
              Soluciones Energéticas
            </Typography>

            {/* Social Links */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
              <IconButton
                size="medium"
                sx={{ 
                  color: 'white',
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
                }}
                href="https://enervia.net"
                target="_blank"
              >
                <LanguageIcon />
              </IconButton>
              <IconButton
                size="medium"
                sx={{ 
                  color: 'white',
                  bgcolor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
                }}
                href="mailto:info@enervia.net"
              >
                <EmailIcon />
              </IconButton>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Chat Section */}
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <SmartToyIcon sx={{ fontSize: 48, color: '#4CAF50', mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            Asistente Virtual de Enervia
          </Typography>
          <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 3 }}>
            Pregúntame sobre nuestros servicios, instalación y mantenimiento de SAI/UPS, soluciones energéticas y más
          </Typography>
        </Box>

        <ChatInterface />
      </Container>
    </Box>
  );
};

export default ModernHome;
